import type { Extension, ForgeUICustomContentExtensionType } from '../types.ts';

export const getAppId = (app: Extension): string | undefined => {
	if (!app?.id) {
		return;
	}

	const [, id] = app.id.split('/');
	return id;
};

export const getModuleKey = (module: Extension): string | undefined => {
	if (!module.id) {
		return;
	}

	const parts = module.id.split('/');
	return parts[parts.length - 1];
};

const isMigratedFromConnect = (app: ForgeUICustomContentExtensionType): boolean => {
	if (!app.properties) {
		return false;
	}
	const props = app.properties as Record<string, unknown>;
	return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};

export const getCustomContentType = (app: ForgeUICustomContentExtensionType): string => {
	if (isMigratedFromConnect(app) && app.migrationKey) {
		return `ac:${app.migrationKey}:${getModuleKey(app)}`;
	}
	return `forge:${getAppId(app)}:${app.environmentId}:${getModuleKey(app)}`;
};
